import React, {
  ReactElement,
  memo,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import textStart from '../../../../assets/png/text_start.png';
import textStart1 from '../../../../assets/png/text_start_1.png';
import textStart2 from '../../../../assets/png/text_start_2.png';
import textStart3 from '../../../../assets/png/text_start_3.png';
import textStart4 from '../../../../assets/png/text_start_4.png';
import textStart5 from '../../../../assets/png/text_start_5.png';
import textStart6 from '../../../../assets/png/text_start_6.png';
import textStart7 from '../../../../assets/png/text_start_7.png';
import textStart8 from '../../../../assets/png/text_start_8.png';
import textStart9 from '../../../../assets/png/text_start_9.png';
import textStart10 from '../../../../assets/png/text_start_10.png';

import textFinish from '../../../../assets/png/text_finish.png';
import textFinish1 from '../../../../assets/png/text_finish_1.png';
import textFinish2 from '../../../../assets/png/text_finish_2.png';
import textFinish3 from '../../../../assets/png/text_finish_3.png';
import textFinish4 from '../../../../assets/png/text_finish_4.png';
import textFinish5 from '../../../../assets/png/text_finish_5.png';
import textFinish6 from '../../../../assets/png/text_finish_6.png';
import textFinish7 from '../../../../assets/png/text_finish_7.png';
import textFinish8 from '../../../../assets/png/text_finish_8.png';
import textFinish9 from '../../../../assets/png/text_finish_9.png';
import textFinish10 from '../../../../assets/png/text_finish_10.png';
import './LiveMatchCountDown.scss';
import { useDispatch, useSelector } from 'react-redux';
import {
  resetDataLiveMatch,
  updateFinishLiveCompetition,
  updateLiveMatchStatus,
} from '../../liveMatchSlice';
import { AppState } from '../../../../store/store';
import {
  LiveMatchKindType,
  LiveMatchStartEnd,
} from '../../types/LiveMatchTypes';
import {
  formatEndLiveMatch,
  fromNowToEndDate,
} from '../../../../common/utils/utils';
import {
  useEndLiveCompetitionsMutation,
  useEndLiveMatchMutation,
  useStartLiveCompetitionsMutation,
} from '../../../../services/api/apiProvider';
import { RequestEndLiveCompetition } from '../../../../services/api/models/request/requestLiveMatch';

let timer: any;

const LiveMatchCountDown = memo((): ReactElement => {
  const dispatch = useDispatch();
  const { statusLiveMatch, liveMatchData, liveCompetitions } = useSelector(
    (state: AppState) => state.liveMatch,
  );
  const live = useSelector((state: AppState) => state.live);
  const currentDate = useRef<Date>(new Date());
  const [noticeFinish, setNoticeFinish] = useState<string | undefined>(
    statusLiveMatch,
  );

  const [timeLiveMatch, setTimeLiveMatch] = useState<number | undefined>(
    liveMatchData?.playingTime,
  );
  const [readyTime, setReadyTime] = useState<number | undefined>(
    liveMatchData?.readyTime,
  );

  const [countDownTime, setCountDownTime] = useState<string>('--:--');
  const [countDownTimeReady, setCountDownTimeReady] = useState('--:--');
  const [countDownEndMatch, setCountDownEndMatch] = useState('--:--');
  const [startLiveCompetitions] = useStartLiveCompetitionsMutation();
  const [endLiveCompetitions] = useEndLiveCompetitionsMutation();
  const [endLiveMatch] = useEndLiveMatchMutation();

  const updateCountDown = useCallback(
    (count?: string, type?: string): string => {
      if (type === 'start') {
        switch (count) {
          case '00:00':
            return textStart;
          case '00:01':
            return textStart1;
          case '00:02':
            return textStart2;
          case '00:03':
            return textStart3;
          case '00:04':
            return textStart4;
          case '00:05':
            return textStart5;
          case '00:06':
            return textStart6;
          case '00:07':
            return textStart7;
          case '00:08':
            return textStart8;
          case '00:09':
            return textStart9;
          case '00:10':
            return textStart10;
          default:
            return '';
        }
      } else {
        switch (count) {
          case '00:00':
            return textFinish;
          case '00:01':
            return textFinish1;
          case '00:02':
            return textFinish2;
          case '00:03':
            return textFinish3;
          case '00:04':
            return textFinish4;
          case '00:05':
            return textFinish5;
          case '00:06':
            return textFinish6;
          case '00:07':
            return textFinish7;
          case '00:08':
            return textFinish8;
          case '00:09':
            return textFinish9;
          case '00:10':
            return textFinish10;
          default:
            return '';
        }
      }
    },
    [],
  );

  useEffect(() => {
    handleTimeMatch();
    return () => {
      dispatch(resetDataLiveMatch());
      clearInterval(timer);
      timer = null;
    };
  }, []);

  useEffect(() => {
    // start competitions when ready time finish
    if (
      !countDownTimeReady &&
      liveMatchData &&
      live.role === 'host' &&
      live.liveData?.id === liveMatchData.live.id
    ) {
      startLiveCompetitions({ liveMatchId: liveMatchData.id }).unwrap();
    }
  }, [countDownTimeReady]);
  // side effect end live competition when match time finish
  useEffect(() => {
    if (
      liveMatchData &&
      liveCompetitions &&
      !countDownTime &&
      live.role === 'host' &&
      live.liveData?.id === liveMatchData?.live.id
    ) {
      const request: RequestEndLiveCompetition = {
        id: liveCompetitions.id,
      };
      endLiveCompetitions(request).unwrap();
    }
  }, [countDownTime]);
  // side effect end live match when match time finish
  useEffect(() => {
    if (
      liveMatchData &&
      liveCompetitions &&
      !countDownEndMatch &&
      live.role === 'host' &&
      live.liveData?.id === liveMatchData?.live.id
    ) {
      endLiveMatch(liveMatchData.id).unwrap();
    }
  }, [countDownEndMatch]);

  const handleTimeMatch = () => {
    if (readyTime && timeLiveMatch && liveMatchData?.keepTime) {
      const endReadyTime = formatEndLiveMatch(
        liveMatchData.startDateTime,
        readyTime,
      );
      const endPlayingTime = formatEndLiveMatch(
        liveMatchData.startDateTime,
        readyTime + timeLiveMatch,
      );
      const endTimeMatch = formatEndLiveMatch(
        liveMatchData.startDateTime,
        readyTime + timeLiveMatch + liveMatchData?.keepTime,
      );
      timer = setInterval(() => {
        currentDate.current = new Date();

        if (currentDate.current < new Date(endReadyTime)) {
          setCountDownTime(fromNowToEndDate(endReadyTime));
          return;
        }
        if (
          currentDate.current >= new Date(endReadyTime) &&
          currentDate.current < new Date(endPlayingTime)
        ) {
          setCountDownTimeReady('');
          setNoticeFinish(LiveMatchStartEnd.FINISH);
          setCountDownTime(fromNowToEndDate(endPlayingTime));
          return;
        }
        if (
          currentDate.current > new Date(endPlayingTime) &&
          currentDate.current < new Date(endTimeMatch)
        ) {
          dispatch(updateFinishLiveCompetition(true));
          dispatch(updateLiveMatchStatus(LiveMatchStartEnd.FINISH));
          setCountDownTime('');
          setCountDownEndMatch(fromNowToEndDate(endTimeMatch));
          return;
        }
        if (currentDate.current > new Date(endTimeMatch)) {
          setCountDownEndMatch('');
          clearInterval(timer);
          return;
        }
      }, 1000);
    }
    if (!readyTime && timeLiveMatch) {
      const endPlayingTime = formatEndLiveMatch(
        liveMatchData?.startDateTime,
        timeLiveMatch,
      );
      timer = setInterval(() => {
        currentDate.current = new Date();
        if (currentDate.current > new Date(endPlayingTime)) {
          clearInterval(timer);
          setCountDownTime('');
          setCountDownEndMatch('');
          return;
        }
        setCountDownTime(fromNowToEndDate(endPlayingTime));
      }, 1000);
    }
  };

  return (
    <>
      <div className="live-match-time">{countDownTime}</div>
      {liveMatchData?.kind === LiveMatchKindType.VS && (
        <div className="live-match-countdown">
          <img src={updateCountDown(countDownTime, noticeFinish)} alt="" />
        </div>
      )}
    </>
  );
});
export default LiveMatchCountDown;
